import React from "react";
import { ComponentProps, PropsWithChildren } from "react";

import "./DangerButton.scss";

function DangerButton({
  children,
  className = "",
  ...restProps
}: PropsWithChildren<ComponentProps<"button">>) {
  return (
    <button {...restProps} className={`danger-btn ${className}`}>
      {children}
    </button>
  );
}

export default DangerButton;
